import * as ng from 'angular';
import {Action, Task} from "../../types/TaskTypes";
import TasksServiceType from "../../tasks/TasksService";

export interface IScope extends  ng.IScope {
    loadingError: boolean;
    loadingInProgressFlag: boolean;
    actionsTakenOnTaskIds: string[];
    takeActionOnTask: (task: Task, action: Action) => void;
    assignedTasks : Task[]
}

const MAX_TASKS_TO_SHOW = 10;

function RecentTasksComponentController($scope: IScope, $log: ng.ILogService, TasksService: TasksServiceType) {
    // Initialization
    $scope.assignedTasks = [];
    $scope.actionsTakenOnTaskIds = [];

    updateTaskList();

    // Actions
    $scope.takeActionOnTask = function(task, action) {
        $log.debug("Taking action " + action.ID + " on Task " + task.Id);
        if ($scope.actionsTakenOnTaskIds.indexOf(task.Id) === -1) {
            $scope.actionsTakenOnTaskIds.push(task.Id);
        }
        TasksService.takeAction(task.Id, action.ID).then(function() {
            // Directly remove the entry from model instead of updating by calling API
            // All tasks are asynchronous which means the task will not be immediately removed after
            // "takeAction" call is made
            removeTask(task);
            updateTaskList();
        });
    };

    function updateTaskList() {
        $log.debug("Updating the task list...");
        $scope.loadingInProgressFlag = true;
        $scope.loadingError = false;
        return TasksService.getAssignedTasks(null)
            .then(function(response) {
                //Only show Tasks that are not acted upon
                $scope.assignedTasks = response.Tasks.filter(task => $scope.actionsTakenOnTaskIds.indexOf(task.Id) === -1);
                $log.debug("The task list length is " + $scope.assignedTasks.length);
                if ($scope.assignedTasks.length > MAX_TASKS_TO_SHOW) {
                    //Truncate the list if there are too many tasks
                    $scope.assignedTasks.length = MAX_TASKS_TO_SHOW;
                }
            }, function(error) {
                $scope.loadingError = true;
                $log.error('failed update task list: ' + JSON.stringify(error));
            })
            .finally(() => {
                $scope.loadingInProgressFlag = false;
            });
    }

    function removeTask(taskParam) {
        $scope.assignedTasks = $scope.assignedTasks.filter(task  => {
            return task.Id === taskParam.Id;
        });
    }
}
RecentTasksComponentController.$inject = ['$scope', '$log', 'TasksService'];

angular.module('GorillaBoy.Dboard')
.controller('RecentTasksComponentController', RecentTasksComponentController);

/*
SAMPLE TASK OBJ
{
  "CreatedTimestamp": 1539028891.566,
  "CreatorId": "S-1-5-21-2475184061-3893120877-1055375187-3701&d-90673160c4",
  "Description": null,
  "Id": "7cf782d8b9aaa39859bb7ecbb46f3099ffa7d10590cdf34e7c591a9d7b57a6b7",
  "Metadata": null,
  "ModifiedTimestamp": 1539028891.566,
  "RelatedResourceId": "74169486d336af051ee2975fff9f19b3ff83bac5328d6803cd7c691708d7fbe1",
  "RelatedResourceType": "Document",
  "State": "INITIAL_STATE",
  "TaskDefinitionId": "cdb892f8-b9cf-49c6-8a3a-a7e678af4002",
  "Title": "Requesting access to document <a class=\"wd-blue-link\" href=\"#/document/74169486d336af051ee2975fff9f19b3ff83bac5328d6803cd7c691708d7fbe1\">name2.docx</a>",
  "TransitionError": null,
  "TransitionStatus": "COMPLETE",
  "CreatedDate": "2018-10-08T20:01:31.566Z",
  "ModifiedDate": "2018-10-08T20:01:31.566Z",
  "Creator": {
    "GivenName": "FrankGmail",
    "Id": "S-1-5-21-2475184061-3893120877-1055375187-3701&d-90673160c4",
    "ProfilePhotoThumbnails": {
      "LARGE": "https://gb-alpha-profile-photos.s3.amazonaws.com/S-1-5-21-2475184061-3893120877-1055375187-3701%26d-90673160c4/LARGE?response-content-disposition=attachment%3B%20filename%2A%3DUTF-8%27%27LARGE&AWSAccessKeyId=AKIAIH7RB27PPEXTTWGA&Expires=1538454716&Signature=nqYDekIRxzRw%2Bvlzr%2FCi5jg3gcA%3D",
      "SMALL": "https://gb-alpha-profile-photos.s3.amazonaws.com/S-1-5-21-2475184061-3893120877-1055375187-3701%26d-90673160c4/SMALL?response-content-disposition=attachment%3B%20filename%2A%3DUTF-8%27%27SMALL&AWSAccessKeyId=AKIAIH7RB27PPEXTTWGA&Expires=1538454716&Signature=bycoYyxfeo1EbEwI%2BeKm6cccpWk%3D",
      "SMALL_HQ": "https://gb-alpha-profile-photos.s3.amazonaws.com/S-1-5-21-2475184061-3893120877-1055375187-3701%26d-90673160c4/SMALL_HQ?response-content-disposition=attachment%3B%20filename%2A%3DUTF-8%27%27SMALL_HQ&AWSAccessKeyId=AKIAIH7RB27PPEXTTWGA&Expires=1538454716&Signature=x0a9Ilo18yLvDaEVO7jvklzldo0%3D"
    },
    "Surname": "Liu"
  },
  "RelatedResourceName": "name2.docx",
  "Actions": [
    {
      "ID": "APPROVE",
      "TextMapping": "Approve"
    },
    {
      "ID": "REJECT",
      "TextMapping": "Reject"
    }
  ]
}
*/